module.exports = __webpack_public_path__ + "img/pic_330018.116b836d.jpg";